<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../stores/dspMng.store";
    import { login_id } from "../stores/auth.store";
    import Header from "../components/Header.svelte";

    let dspList = [];
    let sdate = "";
    let edate = "";

    onMount(() => {
        apiGetDspList();
    });

    async function apiGetDspList() {
        var startDateObj = new Date(sdate);
        var endDateObj = new Date(edate);

        if (startDateObj > endDateObj) {
            alert("시작일은 종료일보다 빨라야 합니다.");
            return;
        }

        dspList = await api.apiGetDspList(sdate, edate);
    }
</script>

<Header />

<div class="menu-title">
    <p class="info-title" style="text-align: center;">출 고 내 역</p>
</div>

<div class="cmn-date" style="margin-top: 15px;">
    <input
        bind:value={sdate}
        type="date"
        id="sdate_m"
        placeholder="날짜를 선택해주세요."
    />
    <p>~</p>
    <input
        bind:value={edate}
        type="date"
        id="edate_m"
        placeholder="날짜를 선택해주세요."
    />
</div>

<div class="cmn-date-btn">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <p on:click={apiGetDspList}>조회</p>
</div>

<div class="main-wrap">
    <div class="list-dtl-wrap scroll-custom">
        <table>
            <tbody>
                <tr>
                    <th>출고번호</th>
                    <th>출고일자</th>
                    <th>출고자</th>
                    <th>수령자</th>
                </tr>

                {#each dspList as data}
                    <tr>
                        <td>{data.dlivy_no}</td>
                        <td>{data.dlivy_de}</td>
                        <td>{data.dlvry_korean_nm}</td>
                        <td>{data.recptr_korean_nm}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>
